// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mirageFormControl {
    width: 100%;
}
.mirageFormControl--widthAuto {
    width: auto !important;
}

.mirageFormControl__inputContainer {
    display: flex;
    gap: 1rem;
}

.mirageFormControl__inputContainer--alignCenter {
    align-items: center;
}

.mirageFormControl__inputContainer--alignBaseline {
    align-items: baseline;
}

.mirageFormControl__errorMsg {
    margin-left: 176px;
    padding-top: 3px;
}
.mirageFormControl__endWatermark {
    font-style: italic;
}

.mirageFormControl {
    margin-bottom: 1rem;
}
.mirageFormControl--width-fitContent {
    width: fit-content;
}
.mirageFormControl--container {
    position: relative;
}
.mirageFormControl__control--stickedToField {
    position: absolute;
    top: -4px;
    left: 70px;
    z-index: 100;
}
.mirageFormControl--view {
    margin-bottom: 1rem;
    align-items: baseline;
}
.mirageFormControl--viewNoMargin {
    margin: 0;
}
.mirageFormControl__infoIcon {
    padding: 0 0 5px 10px;
}
.mirageFormControl__warningIcon {
    padding: 0 0 5px 18px;
}

.mirageFormControl__label {
    line-height: 1rem;
    color: black;
    min-width: 160px;
    width: 160px;
    text-align: right;
    font-weight: 600;
}
.mirageFormControl__label--autoWidth {
    min-width: initial;
    width: auto;
}

.mirageFormControl__label--align-left {
    text-align: left;
}

.mirageFormControl__label--width-100px {
    min-width: 100px;
    width: 100px;
}
.mirageFormControl__errorMsg--margin-120px {
    margin-left: 120px;
}
.mirageFormControl__label--width60 {
    min-width: 60px;
    width: 60px;
}
.mirageFormControl__label--width300 {
    min-width: 300px;
    width: 300px;
}

.mirageFormControl__label--width-fitContent {
    min-width: fit-content;
    width: fit-content;
}

.mirageFormControl__field {
    width: 400px;
    max-width: 400px;
}

.mirageFormControl__field--fullWidth {
    width: 100%;
    max-width: 100%;
}

.mirageFormControl__field--view {
    line-height: 1rem;
    white-space: pre-wrap;
    word-break: break-word;
}
.mirageFormControl__field--gbp {
    width: 80px;
    text-align: end;
}

.mirageFormControl__field input,
.mirageFormControl__field textarea,
.mirageFormControl__field--date input {
    text-overflow: ellipsis;
}

.mirageFormControl__field textarea {
    resize: vertical;
}

.mirageFormControl__field--date {
    width: 224px;
}

.mirageFormControl__field--lookup {
    padding: 1rem;
    min-width: 300px;
    min-height: 100px;
    margin: 1rem;
}

.mirageFormControl__divider {
    margin: 0 5px;
    height: 28px;
}
.mirageCompoundFormControl {
    display: flex;
}
.mirageCompoundFormControl__field {
    width: auto;
    margin-right: 10px;
    margin-bottom: 0;
}

@media (max-width: 900px) {
    .mirageFormControl {
        flex-direction: column;
        gap: 0;
        margin-bottom: 2em;
    }
    .mirageFormControl__label {
        text-align: center;
    }
}

.miragePanelFieldContainer .mirageFormControl__inputContainer {
    display: block;
}
.miragePanelFieldContainer .mirageFormControl__label {
    display: block;
    text-align: left;
    width: auto;
    min-width: initial;
}
.miragePanelFieldContainer .mirageFormControl__field {
    width: 100%;
    max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../mirage/src/components/regularField/Field.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,SAAS;AACb;AACA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;;;IAGI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI;QACI,sBAAsB;QACtB,MAAM;QACN,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,eAAe;AACnB","sourcesContent":[".mirageFormControl {\n    width: 100%;\n}\n.mirageFormControl--widthAuto {\n    width: auto !important;\n}\n\n.mirageFormControl__inputContainer {\n    display: flex;\n    gap: 1rem;\n}\n\n.mirageFormControl__inputContainer--alignCenter {\n    align-items: center;\n}\n\n.mirageFormControl__inputContainer--alignBaseline {\n    align-items: baseline;\n}\n\n.mirageFormControl__errorMsg {\n    margin-left: 176px;\n    padding-top: 3px;\n}\n.mirageFormControl__endWatermark {\n    font-style: italic;\n}\n\n.mirageFormControl {\n    margin-bottom: 1rem;\n}\n.mirageFormControl--width-fitContent {\n    width: fit-content;\n}\n.mirageFormControl--container {\n    position: relative;\n}\n.mirageFormControl__control--stickedToField {\n    position: absolute;\n    top: -4px;\n    left: 70px;\n    z-index: 100;\n}\n.mirageFormControl--view {\n    margin-bottom: 1rem;\n    align-items: baseline;\n}\n.mirageFormControl--viewNoMargin {\n    margin: 0;\n}\n.mirageFormControl__infoIcon {\n    padding: 0 0 5px 10px;\n}\n.mirageFormControl__warningIcon {\n    padding: 0 0 5px 18px;\n}\n\n.mirageFormControl__label {\n    line-height: 1rem;\n    color: black;\n    min-width: 160px;\n    width: 160px;\n    text-align: right;\n    font-weight: 600;\n}\n.mirageFormControl__label--autoWidth {\n    min-width: initial;\n    width: auto;\n}\n\n.mirageFormControl__label--align-left {\n    text-align: left;\n}\n\n.mirageFormControl__label--width-100px {\n    min-width: 100px;\n    width: 100px;\n}\n.mirageFormControl__errorMsg--margin-120px {\n    margin-left: 120px;\n}\n.mirageFormControl__label--width60 {\n    min-width: 60px;\n    width: 60px;\n}\n.mirageFormControl__label--width300 {\n    min-width: 300px;\n    width: 300px;\n}\n\n.mirageFormControl__label--width-fitContent {\n    min-width: fit-content;\n    width: fit-content;\n}\n\n.mirageFormControl__field {\n    width: 400px;\n    max-width: 400px;\n}\n\n.mirageFormControl__field--fullWidth {\n    width: 100%;\n    max-width: 100%;\n}\n\n.mirageFormControl__field--view {\n    line-height: 1rem;\n    white-space: pre-wrap;\n    word-break: break-word;\n}\n.mirageFormControl__field--gbp {\n    width: 80px;\n    text-align: end;\n}\n\n.mirageFormControl__field input,\n.mirageFormControl__field textarea,\n.mirageFormControl__field--date input {\n    text-overflow: ellipsis;\n}\n\n.mirageFormControl__field textarea {\n    resize: vertical;\n}\n\n.mirageFormControl__field--date {\n    width: 224px;\n}\n\n.mirageFormControl__field--lookup {\n    padding: 1rem;\n    min-width: 300px;\n    min-height: 100px;\n    margin: 1rem;\n}\n\n.mirageFormControl__divider {\n    margin: 0 5px;\n    height: 28px;\n}\n.mirageCompoundFormControl {\n    display: flex;\n}\n.mirageCompoundFormControl__field {\n    width: auto;\n    margin-right: 10px;\n    margin-bottom: 0;\n}\n\n@media (max-width: 900px) {\n    .mirageFormControl {\n        flex-direction: column;\n        gap: 0;\n        margin-bottom: 2em;\n    }\n    .mirageFormControl__label {\n        text-align: center;\n    }\n}\n\n.miragePanelFieldContainer .mirageFormControl__inputContainer {\n    display: block;\n}\n.miragePanelFieldContainer .mirageFormControl__label {\n    display: block;\n    text-align: left;\n    width: auto;\n    min-width: initial;\n}\n.miragePanelFieldContainer .mirageFormControl__field {\n    width: 100%;\n    max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
